import React from "react";

const PedicureNearMeDiff = () => {
  return (
    <div className="hairSalonNearMeHead">
      <h3>The SCENT Difference in Nail Art and More</h3>
      <p>
        At SCENT, we don’t just stop at basic pedicure services. For those
        looking to add a splash of creativity, our nail art options are the
        perfect addition. From minimalist designs to bold and intricate
        patterns, we help you express your personality through your nails.
      </p>
      <p>
        So, when you think of pedicure near me think beyond just foot care—think
        of a complete transformation!
      </p>
    </div>
  );
};

export default PedicureNearMeDiff;
